'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = validate;

var _messageBusEventType = require('../model/message-bus-event-type');

var _messageBusEventType2 = _interopRequireDefault(_messageBusEventType);

var _messageBusEventError = require('../errors/message-bus-event-error');

var _messageBusEventError2 = _interopRequireDefault(_messageBusEventError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mandatoryEventProperties = ['eventId', 'eventName', 'eventTime', 'eventVersion', 'namespace', 'eventType', 'eventSource'];

/**
 * @throws {MessageBusEventError} if event is not of type object or does not contain mandatory event properties like eventId, eventName, eventTime etc
 * or if an eventType is set that's not of type ${MessageBusEventType}.
 * @param {*} event - Message Bus Event
 */
function validate(event) {
    if (!(event instanceof Object)) {
        throw new _messageBusEventError2.default('Cannot send an event to Message Bus without an event object');
    }
    var missingEventProperties = [];
    mandatoryEventProperties.forEach(function (mandatoryEvent) {
        if (!Object.keys(event).includes(mandatoryEvent) || event[mandatoryEvent] === null || event[mandatoryEvent] === undefined) {
            missingEventProperties.push(mandatoryEvent);
        }
    });
    if (missingEventProperties.length > 0) {
        throw new _messageBusEventError2.default('Cannot send event to Message bus with missing mandatory event properties: ' + missingEventProperties);
    }
    var eventTypes = _messageBusEventType2.default.values();
    if (!eventTypes.includes(event.eventType)) {
        throw new _messageBusEventError2.default('Cannot send event to Message Bus with an event type that isn\'t a part of these values: ' + eventTypes);
    }
}